import type { LeadPriorityScore, Signal } from '../../domain/signal';
import { HttpClient } from '../../services/HttpClient';

const LEAD_SCORING_API_URL = '/sales-extension/api/lead-scoring/summary';

export type LeadScoringSummaryPayload = {
  domain: string;
  score: LeadPriorityScore;
  triggeredSignals: readonly Signal[];
};

export type LeadScoringSummaryResponseDto = {
  summary: string;
};

export const leadScoringApi = {
  getSummary: (payload: LeadScoringSummaryPayload) => {
    return HttpClient.post<LeadScoringSummaryResponseDto>(LEAD_SCORING_API_URL, payload);
  },
};
